export default {
    GET_LOCALIZATION_SCREEN_SIZES_SUCCESS: (state, data) => {
        state.localizationScreenSizes = data
    },
}